import { useEffect } from "react";
import Masthead from "@/components/site/Masthead";
import Hero from "@/components/site/Hero";
import BeforeAfter from "@/components/site/BeforeAfter";
import LeadForm from "@/components/site/LeadForm";
import Process from "@/components/site/Process";
import Concerns from "@/components/site/Concerns";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import { useReveal } from "@/hooks/useReveal";
import { captureAttribution, initTrackingScripts } from "@/lib/tracking";

export default function Landing() {
  useReveal();

  useEffect(() => {
    document.title = "Sua Piscina PT | Estúdio de visualização residencial";
    captureAttribution();
    initTrackingScripts();
  }, []);

  return (
    <main className="bg-bone text-ink">
      <Masthead />
      <Hero />
      <BeforeAfter />
      <LeadForm />
      <Process />
      <Concerns />
      <FAQ />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
